import useExperiment from 'hooks/useExperiment';
import { useEffect, useState } from 'react';

export const homepageBranchLink = 'https://alltrails.io/rgGVELw1wCb';

const useDeeplink = (pageType?: 'area' | 'trail', pageId?: number) => {
  // Use app homepage deeplink for initial state.
  const [deeplink, setDeeplink] = useState(homepageBranchLink);
  const branchExperiment = useExperiment('web-in-house-branch');

  useEffect(() => {
    const branchLinkBase = 'https://alltrails-alternate.app.link';
    const experiment = 'web-in-house-branch';
    const variant = branchExperiment?.value;

    let appPath = `alltrails://screen/explore`;

    if (pageType && pageId) {
      appPath = `alltrails://${pageType}/${pageId}`;
    }

    const searchParams = new URLSearchParams({
      experiment,
      variant
    });

    // URLSearchParams auto-encodes urls which we don't want for app paths (ex: alltrails://trail/123)
    const branchDeeplink = `${branchLinkBase}?${searchParams.toString()}&$ios_deeplink_path=${appPath}&$android_deeplink_path=${appPath}`;

    setDeeplink(branchDeeplink);
  }, [branchExperiment?.value, pageId, pageType]);

  return deeplink;
};

export default useDeeplink;
